__turbopack_context__.v({
  "bottomBar": "ColorPalette-module__8WxQXW__bottomBar",
  "buttons": "ColorPalette-module__8WxQXW__buttons",
  "categorySection": "ColorPalette-module__8WxQXW__categorySection",
  "categoryTitle": "ColorPalette-module__8WxQXW__categoryTitle",
  "colorGrid": "ColorPalette-module__8WxQXW__colorGrid",
  "colorInput": "ColorPalette-module__8WxQXW__colorInput",
  "colorItem": "ColorPalette-module__8WxQXW__colorItem",
  "colorLabel": "ColorPalette-module__8WxQXW__colorLabel",
  "colorPaletteWrapper": "ColorPalette-module__8WxQXW__colorPaletteWrapper",
  "colorValue": "ColorPalette-module__8WxQXW__colorValue",
  "colorsContainer": "ColorPalette-module__8WxQXW__colorsContainer",
  "copyButton": "ColorPalette-module__8WxQXW__copyButton",
  "downloadButton": "ColorPalette-module__8WxQXW__downloadButton",
  "inputWrapper": "ColorPalette-module__8WxQXW__inputWrapper",
  "labelText": "ColorPalette-module__8WxQXW__labelText",
  "resetButton": "ColorPalette-module__8WxQXW__resetButton",
  "showVarsButton": "ColorPalette-module__8WxQXW__showVarsButton",
  "title": "ColorPalette-module__8WxQXW__title",
  "topBar": "ColorPalette-module__8WxQXW__topBar",
  "uploadButton": "ColorPalette-module__8WxQXW__uploadButton",
  "variablesActions": "ColorPalette-module__8WxQXW__variablesActions",
  "variablesCode": "ColorPalette-module__8WxQXW__variablesCode",
  "variablesHeader": "ColorPalette-module__8WxQXW__variablesHeader",
  "variablesSection": "ColorPalette-module__8WxQXW__variablesSection",
  "variablesTitle": "ColorPalette-module__8WxQXW__variablesTitle",
});
